import { useEnvironmentContext } from '@hooks/context/useEnvironmentContext';
import styles from './TestModeBanner.module.scss';

// Persistent test-mode indicator (Stripe parity: live mode shows no banner —
// the absence of the banner IS the "you're on live" signal). Warning-amber so
// it reads as a mode indicator, not an error.
export default function TestModeBanner() {
    const { env, setEnv } = useEnvironmentContext();
    if (env !== 'test') return null;
    return (
        <div className={styles.banner} role="status">
            <span className={styles.dot} aria-hidden="true" />
            <span className={styles.text}>You&rsquo;re viewing test data. Test-mode activity never touches live money.</span>
            <button type="button" className={styles.action} onClick={() => setEnv('live')}>
                Switch to live
            </button>
        </div>
    );
}
